<template>
  <div class="opple-ability-ui-com-image-icon-enum ">
    <el-popover
      v-model="sShowPopup"
      placement="left"
      width="340"
    >
      <ul class="opple-ability-ui-com-image-icon-enum_imglist">
        <li
          v-for="(img, index) in sceneIconList"
          :key="index"
          class="opple-ability-ui-com-image-icon-enum_img"
          :class="{active: !!img.isSelect }"
          @click="() => handlerIconClick(img, index)"
        >
          <img :src="img.url">
        </li>
      </ul>
      <div
        slot="reference"
        class="planeBox-icon"
      >
        <div class="opple-ability-ui-com-image-icon-enum_icon">
          <img
            :src="iconPreview"
          >
        </div>
      </div>
    </el-popover>  
    <el-input
      v-model="sceneIconName"
      size="medium"
      maxlength="12"
      :placeholder="$t('deviceMsg.keyInput')"
    />
  </div>
</template>

<script>
import { getImageListProxy, getSwitchKeyEventList } from '@/axios/IFttt.js'
import { String2Utf8Array, hexToString } from '@/utils/str';
import { getStrLength } from '@/utils/str';

export default {
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    ui: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      sShowPopup: false,
      iconPreview: 'https://appresource.opple.com/api/icon/type/scene/p12+2',
      sceneIconList: [],
      sceneIconName: ''
    }
  },

  computed: {
   
  },

  mounted() {
    console.log('this.ui', this.ui);
    this.initSceneIcon();
  },

  methods: {
    // 初始化
    async initSceneIcon() {
      try {
        const { DefaultValue } = this.item;
        const sceneIconList = [];
        let iconId = `${17}`;

        Object.entries(this.ui).map(([key, value]) => {
          if (/\d+/.test(key)) {
            sceneIconList.push({
              id: key,
              url: value.detail
            })
          }
        })

        if (!!DefaultValue) {
          const title = DefaultValue.slice(6) || '';
          iconId = `${Number(parseInt(DefaultValue.slice(0, 4), 16))}` || '17';
          this.sceneIconName = hexToString(title);
        }

        this.iconPreview = (this.ui[iconId] || {}).detail || '';
        this.sceneIconList = sceneIconList.map((item, index) => ({
          ...item,
          isSelect: item.id === iconId
        }));
      } catch (e) {
      }
    },

    // 点击icon
    handlerIconClick(img, i) {
      this.iconPreview = img.url;
      this.sceneIconList = this.sceneIconList.map((icon, index) => {
        return {
          ...icon,
          isSelect: i === index
        }
      });
    },

    // 校验
    validate() {
      const limit = 12;
  
      return {
        status: getStrLength(this.sceneIconName) <= limit,
        msg: this.$t("deviceMsg.lengthLimit").replace('{{length}}', `${limit}`),
      }
    },

    // 获取数据
    getData() {
      const iconId = this.sceneIconList.find(item => item.isSelect).id || '01';
      const titleUtf8Array = String2Utf8Array(this.sceneIconName || '');
      const title = titleUtf8Array.map(item => `${Number(item).toString(16)}`).join('');
      const icon = `000${Number(iconId).toString(16)}`.slice(-4);
      
      return {
        Key: this.item.KeyId,
        Values: [`${icon}FF${title}`]
      }
    }

//     async setIconTrigger(itemEnum, item) {
//       const curValue = itemEnum.Value;

//       try {
//         const res = await getSwitchKeyEventList({
//           vDeviceId: this.temdevice.VDeviceId,
//           type: 1,
//           messageType: item.MsgID,
//           nameId: item.PhyPosition
//         })

//         const list = res.Result || [];
//         const history = list.find(item => item.KeyEvent === curValue);
        
//         if (history) {
//           this.sceneIconList = ( this.sceneIconList || []).map((item, index) => ({
//             ...item,
//             isSelect: item.HIcon === history.HIcon,
//           }));
//           // console.log('this.sceneIconList', this.sceneIconList);
          
//           this.sceneIconName = history.Name;
//         //  console.log('res', res);
//         } else {
//           const defaultData = item.UI.enumValueMap ? item.UI.enumValueMap[curValue] : {
//             Icon_h: `https://appresource.opple.com/api/icon/type/scene/p4+2`,
//             CnRemark: `点击编辑按键名称`
//           };


//           this.sceneIconList = ( this.sceneIconList || []).map((item, index) => ({
//             ...item,
//             isSelect: defaultData.Icon_h === item.HIcon,
//           }));
//           this.sceneIconName = defaultData.CnRemark;
//         }
// ``
//         item.isShowIconTrigger = true;
//         item.isShowPopup = false
//       } catch (e) {

//       }
//     },
  },
};
</script>

<style lang="scss">
.opple-ability-ui-com-image-icon-enum {
  display: flex;

  &_icon {
    position: relative;
    width: 36px;
    height: 36px;
    margin-right: 10px;
    background: #efefef;
    border-radius: 50%;
    img {
      width: 100%;
      height: 100%;
    }
  }

  &_imglist {
    box-sizing: border-box;
  }

  &_img {
    width: 36px;
    height: 36px;
    float: left;
    margin-bottom: 10px;
    border-radius: 50%;
    background-color: #efefef;
    border: 2px solid #fff;

    &:not(:nth-child(7n)) {
      margin-right: 10px;
    }

    &.active {
      border-color: #3F70E2;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>